import React, { useEffect, useState } from "react";
import Navbar from "../helpers/Navbar";
import "./newlanding.css";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {  useSelector,useDispatch } from 'react-redux';
import { getProfile } from "../../redux/reducers/profileSlice";
import Footer from "../helpers/Footer";
import { getMyEvents } from "../../redux/reducers/eventSlice";
import { useNavigate } from "react-router-dom";
import { startPayment } from "../helpers/paymentpopup";
import {snackbarContext} from '../helpers/Snakbar'
import Needdates from "../helpers/Needdates";
import { TabTitle } from "../helpers/GeneralFunctions";
const Landing = () => {
    TabTitle("Aamantran Dashboard")
       const navigate=useNavigate()
         
        const setStateSnackbarContext =React.useContext(snackbarContext);
       const { weddingData: data,profileLoaded } = useSelector((state) => state.profile);
          const {events}=useSelector((state)=>state.event)
         const {user}=useSelector((state)=>state.auth)
           const [paymentLoading, setPaymentLoading] = useState(false);
          const now = new Date().getTime();
const expiryTime = new Date(user?.demoExpiryTime).getTime();

const isDemoExpired = user?.demoVersion && expiryTime && now > expiryTime;


   


      const requiredWeddingFields = [

    data?.brideFullName,
    data?.groomFullName,
    data?.weddingDate,
    data?.groomName,
    data?.brideName,
  

];

       const dashboardState = {
    theme: Boolean(data?.theme),
     details: requiredWeddingFields.every(Boolean),
      events: events.length > 0,
        preview: user?.dashboard?.previewViewed,
    share: user?.dashboard?.inviteShared,
};



const completedSteps = Object.values(dashboardState).filter(Boolean).length;

const progress = completedSteps * 20;


      const dispatch=useDispatch();

   useEffect(()=>{
         dispatch(getProfile())
         dispatch(getMyEvents())
   },[])

  // Static values for now
  const userName = user?.name;
const isPurchased = !user?.demoVersion;

const currentStep =
    !dashboardState.theme
        ? "theme"
        : !dashboardState.details
        ? "details"
        : !dashboardState.events
        ? "events"
        : !dashboardState.preview
        ? "preview"
        : "share";


const nextAction = {

    title:
        currentStep === "theme"
            ? "Edit Theme"
            : currentStep === "details"
            ? "Wedding Details"
            : currentStep === "events"
            ? "Add Events"
            : currentStep === "preview"
            ? "Preview Invitation"
            : "Share Invitation",

    helper:
        currentStep === "theme"
            ? "Choose a theme for your invitation."

            : currentStep === "details"
            ? "Add your wedding information."

            : currentStep === "events"
            ? "Create events for your guests."

            : currentStep === "preview"
            ? "See exactly how your guests will experience your invitation."

            : "Share your invitation with your guests.",

    button:
        currentStep === "theme"
            ? "Choose Theme"

            : currentStep === "details"
            ? "Add Wedding Details"

            : currentStep === "events"
            ? "Add Events"

            : currentStep === "preview"
            ? "View Invitation"

            : "Share Invitation",

    path:
        currentStep === "theme"
            ? "/themes"

            : currentStep === "details"
            ? "/details"

            : currentStep === "events"
            ? "/events"

            : currentStep === "preview"
            ? "/preview"

            : "/share"

};

const STEP_CONFIG = {
    theme: {
        path: "/sample-themes"
    },
    details: {
        path: "/details"
    },
    events: {
        path: "/events"
    },
    preview: {
        path: "/preview"
    },
    share: {
        path: "/share"
    }
};

    

const handlePayment=async ()=>{
  if (paymentLoading) return;
  setPaymentLoading(true);
    await startPayment(
        user?.userCode,
        navigate,
        setStateSnackbarContext,
        user?.isAdmin,
        () => setPaymentLoading(false) // callback
      );
}


   useEffect(() => {
    if (!profileLoaded) return;

    if (!data?.theme) {
        setStateSnackbarContext(
            true,
            "Please select Theme",
            "warning"
        );

        navigate("/sample-themes");
    }
}, [profileLoaded, data?.theme, navigate]); 



  return (
    <>
      <Navbar />

    <div
  className={`dashboard-container ${
    user?.demoVersion ? "dashboard-extra-padding" : ""
  }`}
>

      

        <div className="welcome-section">

    <h1 className="welcome-heading">
        {isPurchased
            ? `Welcome back, ${userName} 👋`
            : `Welcome, ${userName} 👋`}
    </h1>

    <p className="welcome-helper">

        {isPurchased
            ? "Manage and update your wedding invitation anytime."
            : "Let's continue building your wedding invitation."}

    </p>

</div>

        {/* Progress */}

{!isPurchased && (
        <div className="progress-card">

          <div className="progress-header">

            <span className="progress-title">
              Invitation Progress
            </span>

            <span className="progress-percent">
              {progress}%
            </span>

          </div>

          <div className="progress-track">

            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            ></div>

          </div>

        </div>
)}
        {/* Next Action */}
{!isPurchased && (
        <div className="next-action-card">

          <div className="next-action-heading">

            <span className="next-action-label">
              Next Action :
            </span>

            <span className="next-action-name">
              {nextAction.title}
            </span>

          </div>

          <p className="next-action-helper">
          {nextAction.helper}
          </p>

          <button className="next-action-btn"  onClick={() => navigate(nextAction.path)}>
             {nextAction.button}
          </button>

        </div>
)}
        {/* Wedding Journey */}

<div className="journey-section">

    <h2 className="journey-heading">
         {isPurchased
        ? "Manage Your Invitation"
        : "Wedding Journey"}
    </h2>

    {isPurchased ? (
    <div className="journey-list">

    <button className="journey-item" onClick={() => navigate(STEP_CONFIG.theme.path)}>

        <div className="journey-left">

            <div className="manage-icon">
                <PaletteOutlinedIcon fontSize="small" />
            </div>

            <span>Edit Theme</span>

        </div>

        <KeyboardArrowRightIcon className="journey-arrow" />

    </button>

    <button className="journey-item"  onClick={() => navigate(STEP_CONFIG.details.path)}>

        <div className="journey-left">

            <div className="manage-icon">
                <BadgeOutlinedIcon fontSize="small" />
            </div>

            <span>Edit Wedding Details</span>

        </div>

        <KeyboardArrowRightIcon className="journey-arrow" />

    </button>

    <button className="journey-item"  onClick={() => navigate(STEP_CONFIG.events.path)}>

        <div className="journey-left">

            <div className="manage-icon">
                <EventNoteOutlinedIcon fontSize="small" />
            </div>

            <span>Manage Events</span>

        </div>

        <KeyboardArrowRightIcon className="journey-arrow" />

    </button>

    <button className="journey-item" onClick={() => navigate(STEP_CONFIG.preview.path)}>

        <div className="journey-left">

            <div className="manage-icon">
                <VisibilityOutlinedIcon fontSize="small" />
            </div>

            <span>Preview Invitation</span>

        </div>

        <KeyboardArrowRightIcon className="journey-arrow" />

    </button>

    <button className="journey-item" onClick={() => navigate(STEP_CONFIG.share.path)}>

        <div className="journey-left">

            <div className="manage-icon">
                <ShareOutlinedIcon fontSize="small" />
            </div>

            <span>Share Invitation</span>

        </div>

        <KeyboardArrowRightIcon className="journey-arrow" />

    </button>

</div>

    ): (
   <div className="journey-list">

        <button className={`journey-item ${
    dashboardState.theme
        ? "completed"
        : currentStep === "theme"
        ? "active"
        : ""
}`}
onClick={() => navigate(STEP_CONFIG.theme.path)}
>

            <div className="journey-left">

                <div className="journey-icon completed-icon">
                    ✓
                </div>

                <span>Edit Theme</span>

            </div>

            <span className="journey-arrow">
                →
            </span>

        </button>

        {/* <button className="journey-item completed">

            <div className="journey-left">

                <div className="journey-icon completed-icon">
                    ✓
                </div>

                <span>Wedding Details</span>

            </div>

            <span className="journey-arrow">
                →
            </span>

        </button> */}

        <button
    className={`journey-item ${
        dashboardState.details
            ? "completed"
            : currentStep === "details"
            ? "active"
            : ""
    }`}
    onClick={() => navigate(STEP_CONFIG.details.path)}
>

    <div className="journey-left">

        <div
            className={`journey-icon ${
                dashboardState.details
                    ? "completed-icon"
                    : ""
            }`}
        >
            {dashboardState.details ? "✓" : "○"}
        </div>

        <span>Wedding Details</span>

    </div>

    <span className="journey-arrow">
        →
    </span>

</button>

     <button
    className={`journey-item ${
        dashboardState.events
            ? "completed"
            : currentStep === "events"
            ? "active"
            : ""
    }`}
      onClick={() => navigate(STEP_CONFIG.events.path)}
>

    <div className="journey-left">

        <div
            className={`journey-icon ${
                dashboardState.events
                    ? "completed-icon"
                    : ""
            }`}
        >
            {dashboardState.events ? "✓" : "○"}
        </div>

        <span>Add Events</span>

    </div>

    <span className="journey-arrow">
        →
    </span>

</button>

       <button
    className={`journey-item ${
        dashboardState.preview
            ? "completed"
            : currentStep === "preview"
            ? "active"
            : ""
    }`}
     onClick={() => navigate(STEP_CONFIG.preview.path)}
>

    <div className="journey-left">

        <div
            className={`journey-icon ${
                dashboardState.preview
                    ? "completed-icon"
                    : ""
            }`}
        >
            {dashboardState.preview ? "✓" : "○"}
        </div>

        <span>Preview Invitation</span>

    </div>

    <span className="journey-arrow">
        →
    </span>

</button>

        <button
    className={`journey-item ${
        dashboardState.share
            ? "completed"
            : currentStep === "share"
            ? "active"
            : ""
    }`}
    onClick={() => navigate(STEP_CONFIG.share.path)}
>

    <div className="journey-left">

        <div
            className={`journey-icon ${
                dashboardState.share
                    ? "completed-icon"
                    : ""
            }`}
        >
            {dashboardState.share ? "✓" : "○"}
        </div>

        <span>Share Invitation</span>

    </div>

    <span className="journey-arrow">
        →
    </span>

</button>
    </div>

    )}

 

</div>
      </div>
     
      <Footer/>

 {isDemoExpired && (
  <div className="payment-overlay">
    <div className="demo-paywall">

      <h2>🔒 Trial Ended – Upgrade to Continue</h2>

      <p className="demo-subtext-1">
        Your trial has ended. Upgrade now to activate your invitation.
      </p>

      <ul className="demo-benefits">

        <li>
          <span className="benefit-icon">📅</span>
          <div>
            <strong>Invite Validity</strong>
            <span>
              Active from upgrade → Until 20 days after your wedding date
            </span>
          </div>
        </li>

        <li>
          <span className="benefit-icon">💳</span>
          <div>
            <strong>One-time payment</strong>
            <span>₹999 · No subscription</span>
          </div>
        </li>

        <li>
          <span className="benefit-icon">✨</span>
          <div>
            <strong>Everything unlocked</strong>
            <span>Remove all trial watermarks, limits & restrictions</span>
          </div>
        </li>

      </ul>

      <p className="demo-subtext-3">
        ⚠️ Your trial data will be deleted in 7 days if you don't upgrade.
      </p>

      <button
        className="upgrade-btn"
        onClick={handlePayment}
      >
        💳 Upgrade for ₹999 →
      </button>

      <span className="paymet-modal-support">
        <i className="fa-brands fa-whatsapp"></i>
        Have a question?
        <strong>Chat on WhatsApp</strong>
      </span>

    </div>
  </div>
)}


{user?.needsDate && <Needdates/>}

       {user?.inviteTimeExpired && (
        <div className="payment-overlay">
         <div className="demo-paywall">
            <h2>🔒 Invite has Expired</h2>
             <p className="demo-subtext-1">
       Thank for choosing aamantran for your big day!!
     </p>
         </div>

        </div>

       )}
 
    </>
  );
};

export default Landing;